import { Box } from '@pco/atoms/Box';
import { Separator } from '@pco/atoms/Separator';
import { DRAWER_KEYS } from '@pco/constants/drawers';
import { CartDrawerCard } from '@pco/molecules/CartDrawerCard';
import { CartDrawerList } from '@pco/molecules/CartDrawerList';
import { useDrawerStore } from '@pco/molecules/DrawerWithStore/useDrawerStore';
import { priceAmountPrint } from '@pco/utils/cart';
import type { CartDrawerContentProps } from './index.types';

export const CartDrawerContent: React.FC<CartDrawerContentProps> = ({
	cardRest,
	listRest,
	product,
	mainCTA,
	secondaryCTA,
	actionCTA,
	quantity,
	subTotal,
	recommendations,
}) => {
	const { height } = useDrawerStore(DRAWER_KEYS.ADD_TO_CART);

	return (
		<Box
			flexDirection="column"
			gap="40px"
			maxWidth="420px"
			paddingTop={(height ?? 0) + 16}
		>
			<CartDrawerCard
				{...cardRest}
				mainCTA={mainCTA}
				secondaryCTA={secondaryCTA}
				productView={product}
				quantity={quantity}
				subtotal={
					subTotal &&
					priceAmountPrint({
						label: '',
						amount: subTotal,
					})
				}
			/>
			<Separator />
			<CartDrawerList
				{...listRest}
				recommendations={recommendations}
				actionCTA={actionCTA}
				sku={product?.sku || ''}
			/>
		</Box>
	);
};
